import { Pause, Play, RotateCcw } from "lucide-react";
import { useEffect, useState } from "react";

const formatTime = (seconds) =>
  `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

function PrepClock({ team, color, seconds, isRunning, onToggle, onReset }) {
  return (
    <div className={`prep-clock ${color}`} data-testid={`${color}-prep-timer`}>
      <div>
        <span className="team-dot"></span>
        <p>{team} prep</p>
      </div>
      <strong data-testid={`${color}-prep-time`}>{formatTime(seconds)}</strong>
      <div className="prep-actions">
        <button
          onClick={onToggle}
          data-testid={`${color}-prep-toggle-button`}
          title={`Start or pause ${team} prep`}
        >
          {isRunning ? <Pause size={15} /> : <Play size={15} />}
        </button>
        <button
          onClick={onReset}
          data-testid={`${color}-prep-reset-button`}
          title={`Reset ${team} prep`}
        >
          <RotateCcw size={15} />
        </button>
      </div>
    </div>
  );
}

export default function PrepTimers({ teams }) {
  const [proSeconds, setProSeconds] = useState(180);
  const [conSeconds, setConSeconds] = useState(180);
  const [proRunning, setProRunning] = useState(false);
  const [conRunning, setConRunning] = useState(false);

  useEffect(() => {
    if (!proRunning) return undefined;
    const timer = window.setInterval(
      () => setProSeconds((current) => Math.max(0, current - 1)),
      1000,
    );
    return () => window.clearInterval(timer);
  }, [proRunning]);
  useEffect(() => {
    if (proSeconds === 0) setProRunning(false);
  }, [proSeconds]);
  useEffect(() => {
    if (!conRunning) return undefined;
    const timer = window.setInterval(
      () => setConSeconds((current) => Math.max(0, current - 1)),
      1000,
    );
    return () => window.clearInterval(timer);
  }, [conRunning]);
  useEffect(() => {
    if (conSeconds === 0) setConRunning(false);
  }, [conSeconds]);

  return (
    <section className="prep-timers" data-testid="prep-timers-section">
      <p className="eyebrow">Preparation time</p>
      <PrepClock
        team={teams.pro}
        color="pro"
        seconds={proSeconds}
        isRunning={proRunning}
        onToggle={() => setProRunning((current) => !current)}
        onReset={() => {
          setProSeconds(180);
          setProRunning(false);
        }}
      />
      <PrepClock
        team={teams.con}
        color="con"
        seconds={conSeconds}
        isRunning={conRunning}
        onToggle={() => setConRunning((current) => !current)}
        onReset={() => {
          setConSeconds(180);
          setConRunning(false);
        }}
      />
    </section>
  );
}
